import dayjs from "dayjs";
import { array, date, number, object, string } from "yup";

export const DEFAULT_VALUES = {
  outlet: null,
  transactionDate: dayjs(),
  note: "",
  outletChartOfAccountTransactions: [],
};

export const VALIDATION_SCHEMA = object().shape({
  outlet: object().required("Harus diisi"),
  transactionDate: date()
    .required("Harus diisi")
    .max(new Date(), "Tanggal tidak boleh di masa depan"),
  note: string().nullable(),
  outletChartOfAccountTransactions: array()
    .min(2, "Harus memiliki setidaknya dua transaksi akun")
    .of(
      object().shape({
        outletChartOfAccount: object().required("Harus diisi"),
        debit: number()
          .transform((value, originalValue) =>
            originalValue === "" ? 0 : value
          )
          .min(0, "Tidak boleh negatif")
          .default(0),
        credit: number()
          .transform((value, originalValue) =>
            originalValue === "" ? 0 : value
          )
          .min(0, "Tidak boleh negatif")
          .default(0),
        note: string().nullable(),
        entityType: string().nullable(),
        entity: object().nullable(),
      })
    )
    .test(
      "debit-credit-exclusive",
      "Setiap baris harus memiliki nilai debit atau kredit, tidak keduanya",
      function (transactions) {
        if (!transactions) return true;

        for (let i = 0; i < transactions.length; i++) {
          const transaction = transactions[i];
          const hasDebit = transaction.debit > 0;
          const hasCredit = transaction.credit > 0;

          if ((hasDebit && hasCredit) || (!hasDebit && !hasCredit)) {
            return this.createError({
              path: `outletChartOfAccountTransactions[${i}]`,
              message:
                "Setiap baris harus memiliki nilai debit atau kredit, tidak keduanya",
            });
          }
        }

        return true;
      }
    )
    .test(
      "balanced-entry",
      "Total debit harus sama dengan total kredit",
      function (transactions) {
        if (!transactions) return true;

        const totalDebit = transactions.reduce(
          (sum, t) => sum + (Number(t.debit) || 0),
          0
        );
        const totalCredit = transactions.reduce(
          (sum, t) => sum + (Number(t.credit) || 0),
          0
        );

        if (Math.abs(totalDebit - totalCredit) > 0.01) {
          return this.createError({
            path: "outletChartOfAccountTransactions",
            message: `Total debit (${totalDebit.toLocaleString()}) harus sama dengan total kredit (${totalCredit.toLocaleString()})`,
          });
        }

        return true;
      }
    ),
});
